export default __webpack_public_path__ + "static/media/logo-masamune-small-white.79a0089b.svg";